import * as Yup from "yup";
import { requiredString } from "../../../utils/validation/comonValidation";

export const attendanceSchema = Yup.object().shape({
  emp_name: requiredString("name is required"),
  reason: requiredString("Reason is required"),
  in_time: Yup.string()
    .transform((v) => (v === "" ? undefined : v))
    .when("editTime", {
      is: (val: string) => val === "0" || val === "2",
      then: (schema) =>
        schema
          .required("In time is required")
          .test(
            "is-before-out-time",
            "In time must be earlier than Out time",
            function (value) {
              const { out_time } = this.parent;
              if (!value || !out_time) return true; // skip if one is empty
              return value <= out_time; // since both are strings like "09:00", lexical compare works
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

  out_time: Yup.string()
    .transform((v) => (v === "" ? undefined : v))
    .when("editTime", {
      is: (val: string) => val === "1" || val === "2",
      then: (schema) =>
        schema
          .required("Out time is required")
          .test(
            "is-after-in-time",
            "Out time must be later than In time",
            function (value) {
              const { in_time } = this.parent;
              if (!value || !in_time) return true; // skip if empty
              return value >= in_time; // works for HH:mm
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
});
